export default {
      id: "ic_carte_interactive-usage",
      viewBox: "0 0 35 35",
      url: "../dist/images/" + "sprite.svg#ic_carte_interactive-usage",
      toString: function () {
        return this.url;
      }
    }